import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "note-grid" }
const _hoisted_3 = { class: "note-grid" }
const _hoisted_4 = { class: "author" }
const _hoisted_5 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "result-title" }, "Notes", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("textarea", {
            id: "story",
            name: "story",
            rows: "3",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addNoteRequest.note) = $event)),
            required: ""
          }, "        ", 512), [
            [
              _vModelText,
              _ctx.addNoteRequest.note,
              void 0,
              { trim: true }
            ]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("button", {
            class: "btn",
            type: "submit"
          }, "+", -1))
        ])
      ], 32),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.userNotes)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.userNotes.userNotes, (note, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "user-notes",
                key: index
              }, [
                _createElementVNode("p", null, _toDisplayString(note.noteText), 1),
                _createElementVNode("p", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Author: ", -1)),
                  _createTextVNode(" " + _toDisplayString(note.customerServiceStaffName), 1)
                ]),
                _createElementVNode("p", _hoisted_5, _toDisplayString(note.createDate), 1),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}